import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function DocumentationTabsHelpers() {
    const { unchangedDocumentation } = useAppSelector((state) => state.documentation);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [formdata, setFormData] = useState({
        id: 0,
        name: '',
        data: null,
        note: null
    });
    const [errors, setErrors] = useState({
        name: ''
    });
    useEffect(() => {
        if (!errors.name) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    useEffect(() => {
        checkBoldFieldsDocumentation();
        unchangedFieldsDocumentation();
    }, [formdata, unchangedDocumentation]);
    const validateForm = () => {
        const newErrors = {
            name: ''
        };
        if (!formdata.name) {
            newErrors.name = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Module Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const { id } = useParams();
    const unchangedFieldsDocumentation = () => {
        if (unchangedDocumentation && formdata && id) {
            let isInfoTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedDocumentation.name != formdata.name ||
                unchangedDocumentation.data != formdata.data ||
                unchangedDocumentation.note != formdata.note ||
                unchangedDocumentation.note != formdata.note) {
                isInfoTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
        }
    };
    const checkBoldFieldsDocumentation = () => {
        if (formdata.name || formdata.data || formdata.note) {
            setIsInfoTabBold(true);
        }
        else {
            setIsInfoTabBold(false);
        }
    };
    return {
        validateForm,
        formdata,
        errors,
        handleFieldChange,
        setFormData,
        infoTabErrorBorderColor,
        isInfoTabUnsaved,
        isInfoTabBold
    };
}
